import { documentCard } from '@/shared/model/document-card.model';
import { getHostName, handleDateTimeCardFeed } from '@/util/ds-util';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
const discoveryReviewState = namespace('discoveryReview');
const listCollectionStore = namespace('listCollection');

@Component({
  computed: {
    isChecked() {
      return this.selectedItems?.findIndex(item => item.id == this.document['id']) > -1;
    },
  },
})
export default class singleCardEdit extends Vue {
  [x: string]: any;
  @Prop(Object) readonly document: any;
  @Prop() readonly selectedItems: any;
  @Prop() readonly isShowDelete: any;
  @Prop() readonly connectomeId: any;
  @Prop() readonly isGotoLink: any | false;
  @Prop() readonly index: any;
  @Prop() readonly isGoPage: any | false;
  @Prop() readonly isHideCheck: any;

  isShowSpinner = false;
  loading = true;
  internalSelectedItems = [];

  selectCard(item) {
    const findIndex = this.internalSelectedItems.findIndex(i => i.docId == item.docId);
    if (findIndex == -1) {
      this.internalSelectedItems.push(item);
    } else {
      this.internalSelectedItems.splice(findIndex, 1);
    }
    this.$emit('setSelectedItems', this.internalSelectedItems);
  }

  checkRegexDate(document) {
    if (isNaN(new Date(document.addedAt).getTime())) {
      document.addedAt = null;
      return;
    }
    const regex = new RegExp('ago');
    if (regex.test(document.addedAt)) return document.addedAt;
    else return new Date(document.addedAt);
  }

  removeCard(item) {
    this.$emit('removeCardReq', item);
    this.$emit('removeCardInList', item);
  }

  addToNewCollection() {
    this.isShowSpinner = true;
  }

  created() {
    this.internalSelectedItems = this.selectedItems;
  }

  hideSpinder() {
    this.isShowSpinner = false;
  }

  handleClick() {
    if (this.isGotoLink) {
      // @ts-ignore
      window.$('#modal-search-report').modal('hide');
      // @ts-ignore
      window.$('#modal-web-report').modal('hide');
      // @ts-ignore
      window.$('#modal-document-report').modal('hide');
      // @ts-ignore
      window.$('#modal-text-report').modal('hide');
    }
  }

  convertObjectDisPreviewToCardDocument(item) {
    const card = new documentCard();
    if (item) {
      card.id = item.docId ? item.docId : null;
      card.author = item.url ? item.url : item?.writer;
      card.title = item.title ? item.title : null;
      card.content = item.description ? item.description : null;
      card.keyword = item.keyword ? item.keyword : null;
      card.type = 'document';
      card.isGroup = false;
      card.url = item.url ? item.url : null;
      card.isAdded = false;
      card.group = [];
      card.tags = item.tags ? item.tags : null;
      card.modifiedAt = item.published_at ? item.published_at : null;
      card.addedAt = null;
      card.style = null;
      card.totalDocuments = 1;
      card.favicon = item.favicon_url || item.favicon_base64 || null;
      card.images.push(item.image_url?.[0] || item.og_image_url || item.og_image_base64);
      card.isBookmarked = true;
    }
    return card;
  }

  imgSource() {
    return this.document?.image_url?.[0] || this.document.og_image_url || this.document.og_image_base64;
  }

  ExtractHostname(url, writer) {
    const name = getHostName(url);
    if (name) return name;
    return writer;
  }

  onErrorImage(document) {
    if (document) {
      document.og_image_url = null;
      document.og_image_base64 = null;
      document.image_url = null;
    }
  }

  getHost(url) {
    if (url == null || url.length == 0) return '';
    let doubleslash = url.indexOf('//');
    if (doubleslash == -1) doubleslash = 0;
    else doubleslash += 2;
    let end = url.indexOf('/', doubleslash);
    end = end >= 0 ? end : url.length;
    const port = url.indexOf(':', doubleslash);
    end = port > 0 && port < end ? port : end;
    return url.substring(doubleslash, end);
  }

  getBaseDomain(url) {
    if (!url || url.indexOf('.') < 0) {
      return url;
    }
    const host = this.getHost(url);
    let startIndex = 0;
    let nextIndex = host.indexOf('.');
    const lastIndex = host.lastIndexOf('.');
    while (nextIndex < lastIndex) {
      startIndex = nextIndex + 1;
      nextIndex = host.indexOf('.', startIndex);
    }
    if (startIndex > 0) {
      return this.upperCaseFirstLetter(host.substring(startIndex), '.');
    } else {
      return this.upperCaseFirstLetter(host, '.');
    }
  }

  upperCaseFirstLetter(str, delimiterBy?) {
    if (!delimiterBy || str.indexOf(delimiterBy) < 0) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    } else {
      str = str.toString().split(delimiterBy)[0];
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  }

  searchTag(tag) {
    this.$router.push('/scrap');
    if (tag && tag.length > 0) {
      this.changeDataTag({ dataTag: tag });
    }
  }
  goPage(document) {
    window.open(document.url);
  }

  processDatetime(datetime) {
    return handleDateTimeCardFeed(datetime, this);
  }
}
